import { all } from 'redux-saga/effects';

import {
  CostPreferenceQuerySaga,
  CostPreferenceUpdateSaga,
  CurrentCostQuerySaga,
  CurrentCostUpdateSaga,
  RemoveAllCostSaga,
  RemoveCostSaga,
} from '@amzn/seller-provided-costs-component';
import ProductSearchSaga from './ProductSearchSaga';
import ProductSearchPageSaga from './ProductSearchPageSaga';
import ProgramMetadataQuerySaga from './ProgramMetadataQuerySaga';
import ProgramFeesQuerySaga from './ProgramFeesQuerySaga';
import WeblabSaga from './WeblabSaga';
import NewProgramFeesQuerySaga from './NewProgramFeesQuerySaga';
import CurrentCountryCodeQuerySaga from './CurrentCountryCodeQuerySaga';
import SelectedProductSaga from './SelectedProductSaga';
import QueryProductSaga from './QueryProductSaga';
import RecommendationQuerySaga from './RecommendationQuerySaga';
import FeeCatQuerySaga from './FeeCatQuerySaga';
import UserPreferenceQuery from 'src/sagas/UserPreferenceQuerySaga';
import UserPreferenceUpdate from 'src/sagas/UserPreferenceUpdateSaga';
import BulkProductSearchSaga from 'src/sagas/BulkProductSearchSaga';
import BulkReportQuerySaga from 'src/sagas/BulkReportQuerySaga';
import UserInputQuery from 'src/sagas/UserInputQuerySage';
import UserInputUpdate from 'src/sagas/UserInputUpdateSage';
import BannerContentQuerySage from 'src/sagas/BannerContentQuerySaga';

function createSagaArray() {
  const sagaArray = [
    ProductSearchSaga(),
    ProductSearchPageSaga(),
    SelectedProductSaga(),
    QueryProductSaga(),
    ProgramMetadataQuerySaga(),
    RecommendationQuerySaga(),
    ProgramFeesQuerySaga(),
    NewProgramFeesQuerySaga(),
    WeblabSaga(),
    CurrentCountryCodeQuerySaga(),
    UserPreferenceQuery(),
    UserPreferenceUpdate(),
    UserInputQuery(),
    UserInputUpdate(),
    BulkProductSearchSaga(),
    BulkReportQuerySaga(),
    FeeCatQuerySaga(),
    BannerContentQuerySage(),
    CurrentCostUpdateSaga(),
    CurrentCostQuerySaga(),
    CostPreferenceQuerySaga(),
    CostPreferenceUpdateSaga(),
    RemoveCostSaga(),
    RemoveAllCostSaga(),
  ];

  return sagaArray;
}

export default function* combinedSaga() {
  // @ts-expect-error
  const sagaArray = yield createSagaArray();

  yield all(sagaArray);
}
